export const lowerCaseFirst = (str: string) => `${str.charAt(0).toLowerCase()}${str.slice(1)}`;
